import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';

import packageJson from '../package.json';
import { AppModule } from './app/app.module';
import { AppInjector } from './app/app-injector';
import { environment } from './environments/environment';

console.log(
  `Optimal is running in ${environment.mode} mode. Current version is ${packageJson.version}.`
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    AppInjector.setInjector(moduleRef.injector);
  })
  .catch((err) => console.error(err));

if (environment.datadog) {
  datadogRum.init({
    applicationId: environment.datadog.applicationId,
    clientToken: environment.datadog.clientToken,
    site: environment.datadog.site,
    env: environment.datadog.env,
    version: packageJson.version,
    service: environment.datadog.service,
    sampleRate: environment.datadog.sampleRate,
    premiumSampleRate: environment.datadog.premiumSampleRate,
    trackInteractions: environment.datadog.trackInteractions,
    trackFrustrations: environment.datadog.trackFrustrations,
    defaultPrivacyLevel: environment.datadog.defaultPrivacyLevel as
      | DefaultPrivacyLevel
      | undefined,
    allowedTracingUrls: environment.datadog.allowedTracingUrls,
  });

  if (environment.datadog.enableSessionReplays) {
    datadogRum.startSessionReplayRecording();
  }
}
